import * as Utils from "../utils/Config";
import { AuthContextModel } from '../App'
import { ApiClient } from "./ApiClient";
import { IRiskPotReport, ICreateRiskPotReport } from "../models/IRiskPotReport";

export class RiskPotReportApi extends ApiClient {
    constructor(auth: AuthContextModel) {
        super(auth);
    }

    getRiskPotReport(riskPotReportId: string, refresh: boolean, success: (riskPotReport: IRiskPotReport) => void, error?: (message: string) => void, final?: () => void) {
        this.get(`${Utils.LIB_API_BASE_URL}/riskPotReport/${riskPotReportId}?refresh=${refresh}`, success, error, final);
    }

    createRiskPotReport(data: ICreateRiskPotReport, success: (riskPotReportId: number) => void, error?: (message: string) => void, final?: () => void) {
        this.postWithResponse(`${Utils.LIB_API_BASE_URL}/riskPotReport`, data, success, error, final);
    }

    deleteRiskPotReport(riskPotReportId: number, success: () => void, error?: (message: string) => void, final?: () => void) {

        this.delete(`${Utils.LIB_API_BASE_URL}/riskPotReport/delete/${riskPotReportId}`, success, error, final);
    }
}